import { Subject } from "rxjs";
import { CompanyList } from "src/app/models/company-list";
import { ApiService } from "src/app/services/api.service";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class SharedService {
  allMarketCompanies: CompanyList[];
  isDataLoaded: Subject<boolean> = new Subject<boolean>();

  constructor(private apiService: ApiService) {
    if (!this.allMarketCompanies)
      this.apiService.fetchAllMarketWatch().subscribe((res: CompanyList[]) => {
        // let temp = res as CompanyList[];

        this.allMarketCompanies = res.filter((company) => {
          return company.MARKET_ID != "INDX";
        });

        this.isDataLoaded.next(true);
      });
  }
}
